/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityDataleaksAggResult } from './MonitEntityDataleaksAggResult';
import {
    MonitEntityDataleaksAggResultFromJSON,
    MonitEntityDataleaksAggResultFromJSONTyped,
    MonitEntityDataleaksAggResultToJSON,
} from './MonitEntityDataleaksAggResult';
import type { MonitEntityDataleaksInnerData } from './MonitEntityDataleaksInnerData';
import {
    MonitEntityDataleaksInnerDataFromJSON,
    MonitEntityDataleaksInnerDataFromJSONTyped,
    MonitEntityDataleaksInnerDataToJSON,
} from './MonitEntityDataleaksInnerData';

/**
 * 
 * @export
 * @interface EntityDataLeaksAggResponse1
 */
export interface EntityDataLeaksAggResponse1 {
    /**
     * 
     * @type {number}
     * @memberof EntityDataLeaksAggResponse1
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityDataLeaksAggResponse1
     */
    total_emails?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof EntityDataLeaksAggResponse1
     */
    emails?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EntityDataLeaksAggResponse1
     */
    features?: Array<string>;
    /**
     * 
     * @type {Array<MonitEntityDataleaksInnerData>}
     * @memberof EntityDataLeaksAggResponse1
     */
    events?: Array<MonitEntityDataleaksInnerData>;
}

/**
 * Check if a given object implements the EntityDataLeaksAggResponse1 interface.
 */
export function instanceOfEntityDataLeaksAggResponse1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EntityDataLeaksAggResponse1FromJSON(json: any): EntityDataLeaksAggResponse1 {
    return EntityDataLeaksAggResponse1FromJSONTyped(json, false);
}

export function EntityDataLeaksAggResponse1FromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityDataLeaksAggResponse1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'total_emails': !exists(json, 'total_emails') ? undefined : json['total_emails'],
        'emails': !exists(json, 'emails') ? undefined : json['emails'],
        'features': !exists(json, 'features') ? undefined : json['features'],
        'events': !exists(json, 'events') ? undefined : ((json['events'] as Array<any>).map(MonitEntityDataleaksInnerDataFromJSON)),
    };
}

export function EntityDataLeaksAggResponse1ToJSON(value?: EntityDataLeaksAggResponse1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'total_emails': value.total_emails,
        'emails': value.emails,
        'features': value.features,
        'events': value.events === undefined ? undefined : ((value.events as Array<any>).map(MonitEntityDataleaksInnerDataToJSON)),
    };
}

